module.exports = __webpack_public_path__ + "static/media/Galeri_13.3d216a03.jpg";